'use client';

import { c as _c } from "react/compiler-runtime";
import { useAtomValue } from 'jotai';
import { pdpParamsWithSyncAtom } from '@/atoms/pdpParamsAtom';
import { CyoImageGallery } from './CyoImageGallery';
type CYOImageGalleryWrapper = {
  productType: ClientProductType;
  modelImages: ModelImage[] | undefined;
  isSpreadBrand?: boolean;
};
export const CYOImageGalleryWrapper = t0 => {
  const $ = _c(5);
  const {
    productType,
    modelImages,
    isSpreadBrand
  } = t0;
  const pdpParams = useAtomValue(pdpParamsWithSyncAtom);
  const appearanceId = pdpParams?.appearanceId ?? productType.defaultValues.defaultAppearance.id;
  let t1;
  if ($[0] !== appearanceId || $[1] !== isSpreadBrand || $[2] !== modelImages || $[3] !== productType) {
    t1 = <CyoImageGallery productType={productType} modelImages={modelImages} appearanceId={appearanceId} isSpreadBrand={isSpreadBrand} />;
    $[0] = appearanceId;
    $[1] = isSpreadBrand;
    $[2] = modelImages;
    $[3] = productType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};